import _ from 'lodash';
const combineValidators = (...validationFunctions) => (value) => _.reduce(validationFunctions, (isValid, validationFunction) => isValid && validationFunction(value), true);
export { combineValidators };
